import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class meiCanoneZeroPlusPlus {
  public static offerta(): Offerte {
    return {
		Flg_Indicizzato: false,
      Id_Offerta: 308,
      Id_Foritore: 3,
      Id_comodity: 1,
      TipoContratto: 1,
      NomeOfferta: "CANONE ZERO++",
      LinkFoto: "./assets/images/offerte-mei/canone-zero-ELE-plusplus.jpg",
      LinkFotoLarge: "./assets/images/offerte-mei/canone-zero-ELE-plusplus.jpg",
      LinkFotoMid: "./assets/images/offerte-mei/canone-zero-ELE-plusplus.jpg",
      LinkFotoSm: "./assets/images/offerte-mei/canone-zero-ELE-plusplus.jpg",
      LinkFotoCarousel: "./assets/images/offerte-mei/canone-zero-ELE-plusplus.jpg",
      DescrizioneCarousel: "Che Offerta super",
      DescrizioneNomeOfferta: "L’offerta luce che rispetta l’ambiente",
      PromozioneOfferta: "",
      Sezioni: [
        {
          NomeSezione: "VANTAGGI ASSICURATI",
          DescrizioneSezione: "45€ di SCONTO ANNUALE, ENERGIA AL 100% VERDE SENZA COSTI AGGIUNTI",
          lstPunti: []
        },
      ],
      PrezzoEle: 0.07790,
      PrezzoGas: 0,

      TitoloPlus: "VANTAGGI ASSICURATI",
      Plus: ["45€ di SCONTO ANNUALE, ENERGIA AL 100% VERDE SENZA COSTI AGGIUNTI"]


      , schedaconfrontabilitaele: {
        tabellaConfrontabilita: [
          { consumoannuo: 1200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 311.03 }
          , { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 579.30 }
          , { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 671.33 }
          , { consumoannuo: 4500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 838.15 }
          , { consumoannuo: 1200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 311.03 }
          , { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 579.81 }
          , { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 671.33 }
          , { consumoannuo: 4500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 838.15 }
          , { consumoannuo: 1200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 311.03 }
          , { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 579.81 }
          , { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 671.33 }
          , { consumoannuo: 4500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 838.15 }
          , { consumoannuo: 1200, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 443.31 }
          , { consumoannuo: 2700, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 662.64 }
          , { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 790.85 }
          , { consumoannuo: 4500, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 951.05 }
          , { consumoannuo: 1200, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 443.31 }
          , { consumoannuo: 2700, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 662.64 }
          , { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 790.85 }
          , { consumoannuo: 4500, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 951.05 }
          , { consumoannuo: 1200, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 443.31 }
          , { consumoannuo: 2700, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 662.64 }
          , { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 790.85 }
          , { consumoannuo: 4500, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 951.05 }
          , { consumoannuo: 1200, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 870.09 }
          , { consumoannuo: 1200, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 870.09 }
          , { consumoannuo: 1200, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 870.09 }
          , { consumoannuo: 1200, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 870.09 }
          , { consumoannuo: 1200, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 870.09 }
          , { consumoannuo: 1200, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 342.97 }
          , { consumoannuo: 2700, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 569.75 }
          , { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 703.23 }
          , { consumoannuo: 4500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 870.09 }
        ]
      }




      , schedaconfrontabilitagas:
      {
        tabellaConfrontabilita: []
      }
      , lstModalitaPagamento: ["1", "2"]
      , scontoRid: 36
      , TipoSoglieEle: Soglie.SogliaMomoEleOld()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/meiCanoneZeroPlusPlus.ts